<template>
  <div>
    <b-row>
      <b-row style="color:red;font-size:15pt;">
        이메뉴에 api response 체크 필
      </b-row>

      <b-colxx xxs="12">
        <b-card class="mb-4" title="주말 설정">
          <b-form-group label-cols="2" horizontal label="주말인정요일">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col cols="1">
                <span>시작 요일</span>
                <b-form-select class="mt-2" v-model="startDayOfWeek" :options="weekdayOptions" plain/>
                <b-form-select class="mt-2" v-model="startHourOfStartDay" :options="hourOfDayOptions" plain/>
              </b-col>
              <b-col md="auto" class="ml-4 mt-4">
                <span>~</span>
              </b-col>
              <b-col cols="1" class="ml-4">
                <span>종료 요일</span>
                <b-form-select class="mt-2" v-model="endDayOfWeek" :options="weekdayOptions" plain/>
                <b-form-select class="mt-2" v-model="endHourOfEndDay" :options="hourOfDayOptions" plain/>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="주말에 공휴일 포함 여부">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="includeNationalHoliday">
                  <b-form-radio value="true">포함함</b-form-radio>
                  <b-form-radio value="false">포함하지 않음</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-form-group>

          <b-button variant="outline-primary" class="mt-4" @click.prevent="goBack">뒤로</b-button>
          <b-button variant="primary" class="mt-4 ml-2" @click.prevent="onSave">저장</b-button>
        </b-card>
      </b-colxx>
    </b-row>

  </div>
</template>
<script>
  import 'vue-select/dist/vue-select.css'
  import api from '../../../constants/api'
  import {
    mapGetters,
    mapActions
  } from "vuex";

  export default {
    data() {
      return {
        storeCode: this.$route.params.storeCode,
        includeNationalHoliday: false,
        startDayOfWeek: 1,
        startHourOfStartDay: null,
        endDayOfWeek: 7,
        endHourOfEndDay: null,
        weekdayOptions: [
          {value: 1, text: '월'},
          {value: 2, text: '화'},
          {value: 3, text: '수'},
          {value: 4, text: '목'},
          {value: 5, text: '금'},
          {value: 6, text: '토'},
          {value: 7, text: '일'}
        ],
        hourOfDayOptions: [
          {value: null, text: '종일'},
          {value: '00', text: '00 시'},
          {value: '01', text: '01 시'},
          {value: '02', text: '02 시'},
          {value: '03', text: '03 시'},
          {value: '04', text: '04 시'},
          {value: '05', text: '05 시'},
          {value: '06', text: '06 시'},
          {value: '07', text: '07 시'},
          {value: '08', text: '08 시'},
          {value: '09', text: '09 시'},
          {value: '10', text: '10 시'},
          {value: '11', text: '11 시'},
          {value: '12', text: '12 시'},
          {value: '13', text: '13 시'},
          {value: '14', text: '14 시'},
          {value: '15', text: '15 시'},
          {value: '16', text: '16 시'},
          {value: '17', text: '17 시'},
          {value: '18', text: '18 시'},
          {value: '19', text: '19 시'},
          {value: '20', text: '20 시'},
          {value: '21', text: '21 시'},
          {value: '22', text: '22 시'},
          {value: '23', text: '23 시'},
        ]
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    methods: {
      goBack() {
        this.$router.back();
      },
      loadData() {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.weekendSettings)
        const params = {
          storeCode: this.storeCode
        }

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            console.log(res.data.data)
            this.startDayOfWeek = res.data.data.startDayOfWeek
            this.startHourOfStartDay = res.data.data.startHourOfStartDay
            this.endDayOfWeek = res.data.data.endDayOfWeek
            this.endHourOfEndDay = res.data.data.endHourOfEndDay
            this.includeNationalHoliday = res.data.data.includeNationalHoliday
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })

      },
      onSave() {

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.weekendSettingsUpdate)
        const params = {
          storeCode: this.storeCode,
          startDayOfWeek: this.startDayOfWeek,
          startHourOfStartDay: this.startHourOfStartDay,
          endDayOfWeek: this.endDayOfWeek,
          endHourOfEndDay: this.endHourOfEndDay,
          includeNationalHoliday: this.includeNationalHoliday
        }

        this.$http.post(reqURL, params,
          {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}}).then(res => {
          if (res.data.code === "OK") {
            alert('변경되었습니다')
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },
  }
</script>
